import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '热播': 'bg-primary-100 text-primary-700',
  '新番': 'bg-accent-100 text-accent-700',
  '更新': 'bg-secondary-100 text-secondary-700',
  '预告': 'bg-foreground-100 text-foreground-700',
  '首播': 'bg-primary-100 text-primary-700',
  '推荐': 'bg-accent-100 text-accent-700',
  '独家': 'bg-primary-100 text-primary-700',
  '回顾': 'bg-secondary-100 text-secondary-700',
};

export default function LatestUpdates() {
  return (
    <section className="py-12 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <div className="w-1 h-5 bg-secondary-500 rounded-full"></div>
            <h2 className="text-lg font-heading font-semibold text-foreground-900">最新更新</h2>
          </div>
          <Link to="/category" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap">
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="bg-background-100 rounded-xl p-1">
          {latestUpdates.map((item, index) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className={`flex items-center gap-4 px-4 py-3.5 hover:bg-background-200/60 transition-colors cursor-pointer ${
                index === 0 ? 'rounded-t-xl' : ''
              } ${index === latestUpdates.length - 1 ? 'rounded-b-xl' : ''} ${
                index < latestUpdates.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 text-xs font-medium shrink-0">
                {String(index + 1).padStart(2, '0')}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-900 font-medium truncate">{item.title}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{item.category}</span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium shrink-0 ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                {item.tag}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}